/**
 * Food Pulse Deals / Coupons / Surplus taxonomy.
 *
 * Ordered exactly as shown in the mobile mockup so users see the
 * same list on every device. Backend accepts any of these values in
 * the ``deal_type`` field of `fp_deals`.
 */
export const DEAL_TYPES = [
  "Flash Sale",
  "Flat Money Off",
  "Free Item Offer",
  "Holiday or Festival Special",
  "Imperfect Produce",
  "Last-Minute Deals",
  "Loyalty Exclusive Offer",
  "Meal or Recipe Kit Discount",
  "Mystery Bag",
  "Neighborhood Support Special",
  "Percentage Discount",
  "Ready-to-Eat Meals / Salads",
  "Spend & Get Free",
  "Surplus Stock Offer",
  "Time-of-Day Deals",
  "Unexpired Medicine & Supplies",
  "Home Produce Give Away",
  "Discount Price",
];

// "Kind" — top-level bucket the deal falls under.
export const DEAL_KINDS = [
  { value: "offer",   label: "Deals/Offers" },
  { value: "coupon",  label: "Coupons" },
  { value: "surplus", label: "Surplus Deals" },
];
